/// <reference path="../typings/index.d.ts" />
/// <reference path="Locate.d.ts" />
namespace App {
    export class Locate implements ILocate {
        public getMessages(locate: string) {
            switch (locate) {
                case 'en':
                    return this.getMessagesEn();
                case 'es':
                    return this.getMessagesEs();
                case 'pt-br':
                default:
                    return this.getMessagesPtBr();
            }
        }

        private getMessagesPtBr(): ILocateMessages {
            return {
                extensao_instalada_titulo: "Extensão não instalada!",
                extensao_instalada_texto: "A extensão FutSniperWeb não está instalada no seu navegador ou está desatualizada ou não foi instalada corretamente."
            };
        }

        private getMessagesEn(): ILocateMessages {
            return {
                extensao_instalada_titulo: "Extension not installed!",
                extensao_instalada_texto: "FutSniperWeb extension is not installed on your browser or is out of date or not installed correctly."
            };
        }

        private getMessagesEs(): ILocateMessages {
            return {
                extensao_instalada_titulo: "Extensión no instalada!",
                extensao_instalada_texto: "La extensión FutSniperWeb no está instalada en su navegador o está desactualizada o no está instalada correctamente."
            };
        }
    }
}
